import { render, staticRenderFns } from "./maxApplicants.vue?vue&type=template&id=1ec37bd0&scoped=true&"
import script from "./maxApplicants.vue?vue&type=script&lang=js&"
export * from "./maxApplicants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec37bd0",
  null
  
)

export default component.exports